import service from "@/utils/request";



export const login = async (email, password) => {
  try {
    const response = await service.post(`/login`, { email, password });
    return response;
  } catch (error) {
    throw new Error("An error occurred.");
  }
};
